export default __webpack_public_path__ + "static/media/star.a46cf518.wav";